import explore_image from '@/public/features/explore.webp';
// import schedule_3 from '@/public/features/sales/Streamline-Payment-Processes-with-Ease.webp';
import app_1 from '@/public/features/gps_tracking/App_1.webp';
import schedule_5 from '@/public/features/job_tracking/Detailed Reporting.webp';
import schedule_1 from '@/public/features/job_tracking/Job Time Tracking.webp';
import bg from '@/public/features/job_tracking/Main.webp';
import schedule_4 from '@/public/features/job_tracking/Payroll Management.webp';
import schedule_2 from '@/public/features/job_tracking/Profit and Loss Calculation.webp';
import app_2 from '@/public/features/job_tracking/What Is Job Tracking Software_.webp';
import { CalendarIcon, CardIcon, ToolsIcon, WalletIcon } from '@/public/icons';
import { ArticleType } from '@/types/articles';
import { IRoutePath } from '@/types/router';

const intro = {
  tag: 'Job Tracking Software',
  description: `Our free job tracking software simplifies management for field service professionals. With a free job tracking app and streamlined tasks, you can improve efficiency, and boost productivity. Experience seamless job tracking and enhanced organization today.`,
  imageSrc: bg.src,
  image: bg,
  first_title: 'Free Job Tracking Software',
  second_title: ' for Field Service Professionals',
};

const faq = {
  title: 'FAQ',
  items: [
    {
      title: `How to Choose the Best Job Tracking Software for My Needs?`,
      text: `Select software that easily integrates into your existing systems and is well-equipped with features like real-time updates, scalable functionality, and user-friendly interfaces. It should correspond with your particular industry needs and have a good support system.`,
    },
    {
      title: `What Are the Benefits of Service Tracking Software for My Business?`,
      text: `Service tracking software increases efficiency operationally by reducing downtime, managing communication effectively between field staff and administration, and taking a proactive approach to the management of services.`,
    },
    {
      title: `Is Orcatec Job Tracking Software Free?`,
      text: `Yes, Orcatec offers a completely free entry-level plan that provides essential job-tracking capabilities. This plan is an excellent choice for any businesses or startups seeking to enhance their services without initial investment.`,
    },
    {
      title: `Can I Customize Orcatec's Job Tracking Software?`,
      text: `Orcatec job logging software is modular and configurable to your working needs. You pay for what you only need. When you require to configure the software, as your business grows and changes, modularity means it will always be suitable.`,
    },
    {
      title: `How Does Job Tracking Software Improve Daily Operations?`,
      text: `With the job track software, task assignments will be automated, while tracking the progress of the job in real-time will provide detailed analytics on job completion and employee activity. This software streamlines operations, reduces administrative burden, grants you the ability to choose the best allocation of resources, and ultimately increases business productivity.`,
    },
  ],
};

const testimonals = {
  title: 'Client’s Testimonials',
  description: '',
  items: [
    {
      text: `Orcatec's free plan allowed us to improve our job management without initial investment. The customizability as we expand is truly the best match for our operations.`,
      name: 'Sarah L.',
      position: 'Operations Manager',
    },
    {
      text: `Since adopting Orcatec, our team’s productivity has soared. The detailed insights from the software help us make quick, informed decisions, enhancing our project management capabilities substantially.`,
      name: 'James H.',
      position: 'HR Manager',
    },
    {
      text: `Fantastic support from Orcatec! They're always ready to assist, ensuring we never miss a beat in our service delivery. Their fast and reliable help makes a real difference.`,
      name: 'Emily W.',
      position: 'Compliance Officer.',
    },

    {
      text: `Orcatec's free plan allowed us to improve our job management without initial investment. The customizability as we expand is truly the best match for our operations.`,
      name: 'Sarah L.',
      position: 'Operations Manager',
    },
    {
      text: `Since adopting Orcatec, our team’s productivity has soared. The detailed insights from the software help us make quick, informed decisions, enhancing our project management capabilities substantially.`,
      name: 'James H.',
      position: 'HR Manager',
    },
    {
      text: `Fantastic support from Orcatec! They're always ready to assist, ensuring we never miss a beat in our service delivery. Their fast and reliable help makes a real difference.`,
      name: 'Emily W.',
      position: 'Compliance Officer.',
    },
  ],
};

const blog = {
  title: 'Our Blog',
  description: `Explore the latest insights and trends in job and service tracking software through our blog. Learn how innovative solutions can transform your business operations and increase efficiency.`,
};

const bookDemo = {
  title: `Ready to Elevate Your\xa0Business\xa0Efficiency?`,
  description: `Take the first action towards altering your service management with Orcatec. If you have any questions or need personalized advice on implementing our free job tracker software, please fill out the contact form below.`,
};

const articles = {
  title: `How Does Job Tracking\xa0Software\xa0Work?`,
  items: [
    {
      type: ArticleType.VERICAL,
      image: {
        path: schedule_1,
        alt: 'On-Site Proposal Creation',
      },
      list: [],
      href: '#',
      tag: '',
      title: 'Job Time Tracking',
      text: `Track your employees' drive time to work sites and time spent on different jobs to ensure that routes are optimized, fuel is saved, and employees are using their time productively. Tracking such data collection with this timer, through a business's workforce, can increase productivity and eliminate unnecessary downtime.`,
    },

    {
      type: ArticleType.VERICAL,
      image: {
        path: schedule_2,
        alt: 'Customer management',
      },
      list: [],
      href: '#',
      tag: '',
      title: 'Profit and Loss Calculation',
      text: `Monitor all the expenses and labor costs for each job across your business. This helps businesses calculate accurately the profit margins of each project and provides a lot of financial transparency and proper budgeting. This will open a lot of opportunities for cost savings, hence better financial management of expenses and labor costs.`,
    },

    /*  {
      type: ArticleType.HORIZONTAL,
      image: {
        path: schedule_3,
        alt: 'Streamlined Approval Process',
      },
      list: [],
      href: '#',
      tag: '',
      title: `Customizable and Personalized\xa0Proposals`,
      text: `At the core of the software's functionality is its ability to produce highly customizable and personalized proposals. You can tailor every aspect of the proposal, from headers and layouts to itemized or total pricing, ensuring that each proposal reflects the unique value proposition you offer to the client.\n\nThis level of personalization helps to create a connection with the client and demonstrates a deep understanding of their needs.`,
    }, */
    {
      type: ArticleType.VERICAL,
      image: {
        path: schedule_5,
        alt: 'Customer management',
      },
      list: [],
      href: '#',
      tag: '',
      title: 'Detailed Reporting',
      text: `Generate in-depth, detailed reports on individual users or certain projects. Such reporting provides insight into performance metrics that, in turn, allow managers to evaluate productivity, find out what might be affecting this or that, and, therefore, make informed business decisions.\n\nDetailed reporting ensures that businesses can track progress, measure success, and, therefore, optimize operations toward factual data.`,
    },
    {
      type: ArticleType.VERICAL,
      image: {
        path: schedule_4,
        alt: 'Customer management',
      },
      list: [],
      href: '#',
      tag: '',
      title: 'Payroll Management',
      text: `Create and manage accurate payrolls for your workers easily from the tracked hours and job completion data. So, your workers are paid equitably and precisely.\n\nAutomated payroll management saves administrative time, minimizes mistakes, and ensures labor law compliance. Streamlining the payroll process leads to the highest level of employee satisfaction and operational efficiency.`,
    },
  ],
};

const fullArticle1 = {
  image: {
    path: app_1,
    alt: `Why Orcatec is Right For You?`,
  },
  title: `Why Orcatec is\xa0Right\xa0For\xa0You?`,
  description: `Orcatec provides advanced and tailored job tracking software specifically designed for field service businesses and contractors. Explore the powerful benefits of choosing Orcatec and see how it can revolutionize your operational management and enhance your overall business performance:`,
  item: [
    {
      title: 'Complimentary Starter Package',
      description:
        'Orcatec provides a unique no-cost starter package that stands out from the competition. This complimentary plan grants you access to essential job-tracking functionalities, allowing you to begin organizing your operations without any financial commitment.',
    },
    {
      title: 'Tailored Solutions',
      description: `Understanding that each contractor's needs vary, Orcatec enables you to customize your subscription by selecting only the features that are relevant to your business. This flexibility allows your package to scale with your operations, helping you avoid overspending while enhancing your operational efficiency.`,
    },
    {
      title: 'Fast, Reliable Online Support',
      description: `Our on-time, reliable online support will make sure you never have to work in the dark alone. The Orcatec support team will help you with all problems and ensure your operations run smoothly.`,
    },
  ],
};

const fullArticle2 = {
  image: {
    path: app_2,
    alt: `What Is Job Tracking Software?`,
  },
  title: `What Is Job\xa0Tracking\xa0Software?`,
  description: `Job tracking software, like Orcatec, offers robust features for managing field service tasks. It ensures timely job completion, enhances communication, and increases accountability. Businesses benefit from streamlined operations and reduced errors, while customers enjoy prompt service and clear communication.`,
  item: [
    {
      title: '',
      description: 'Orcatec helps ensure tasks are completed on schedule',
    },
    {
      title: '',
      description: 'Streamlined communication keeps everyone informed',
    },

    {
      title: '',
      description: `Tracking features improve accountability and reduce errors`,
    },
  ],
};

const explore = {
  title: 'Explore More ',
  subtitle: 'Tools For Job Success',
  description: `Dive into a wealth of insights tailored to your industry with Orcatec's blog, your go-to resource 
  for the latest trends and tips in service scheduling software free`,
  image: explore_image,
  items: [
    {
      title: 'Complete Job & Invoice',
      path: IRoutePath.FEATURES_INVOICING,
      icon: WalletIcon,
      items: [
        {
          title: 'Sales Proposal Tool',
          path: '',
        },

        {
          title: 'Invoicing',
          path: '',
        },
        {
          title: 'Estimates',
          path: '',
        },
        {
          title: 'Quoting',
          path: '',
        },
      ],
    },
    {
      title: 'Scheduling & Dispatching',
      path: IRoutePath.FEATURES_SCHEDULIG,
      icon: CalendarIcon,
      items: [
        {
          title: 'Employee GPS Tracking',
          path: '',
        },
        {
          title: 'Scheduling Software',
          path: '',
        },
        {
          title: 'Route Optimization',
          path: '',
        },
        {
          title: 'Field Service App',
          path: '',
        },
        {
          title: 'Voice Solutions',
          path: '',
        },
        {
          title: 'Dispatching',
          path: '',
        },
      ],
    },
    {
      title: 'Get Paid & Expenses',
      path: IRoutePath.FEATURES,
      icon: CardIcon,
      items: [
        {
          title: 'Commissions Management',
          path: '',
        },
        {
          title: 'Home Services Marketing',
          path: '',
        },
        {
          title: 'Automated Direct Mail',
          path: '',
        },
        {
          title: 'Consumer Financing',
          path: '',
        },
        {
          title: 'Advanced Reporting',
          path: '',
        },
        {
          title: 'Expenses Tracking',
          path: '',
        },

        {
          title: 'Contractor Payroll',
          path: '',
        },
        {
          title: 'Card Reader',
          path: '',
        },
      ],
    },
    {
      title: 'Job Management',
      icon: ToolsIcon,
      path: IRoutePath.FEATURES,
      items: [
        {
          title: 'Work Order Management',
          path: '',
        },
        {
          title: 'Field Service CRM',
          path: '',
        },
        {
          title: 'Job Management',
          path: '',
        },
        {
          title: 'Job Tracking',
          path: '',
        },
        {
          title: 'Job Costing',
          path: '',
        },
      ],
    },
  ],
};

export {
  articles,
  blog,
  bookDemo,
  faq,
  fullArticle1,
  fullArticle2,
  intro,
  testimonals,
  explore,
};
